import React, { Fragment, ReactNode } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTimes } from '@fortawesome/free-solid-svg-icons';
import { Dialog, Transition } from '@headlessui/react';

import styles from './Modal.module.css';

export const Modal = ({
  children,
  open,
  onClose,
  closeButton = true,
  containerStyles,
}: {
  children: ReactNode;
  open: boolean;
  onClose: () => void;
  closeButton?: boolean;
  containerStyles?: string;
}) => {
  return (
    <Transition.Root show={open} as={Fragment}>
      <Dialog as="div" className="relative z-[99] h-full" onClose={onClose}>
        <Transition.Child
          as={Fragment}
          enter="ease-out duration-300"
          enterFrom="opacity-0"
          enterTo="opacity-100"
          leave="ease-in duration-200"
          leaveFrom="opacity-100"
          leaveTo="opacity-0"
        >
          <div className={styles.transition} />
        </Transition.Child>

        <div className={containerStyles || styles.container}>
          <Transition.Child
            as={Fragment}
            enter="ease-out duration-300"
            enterFrom="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
            enterTo="opacity-100 translate-y-0 sm:scale-100"
            leave="ease-in duration-200"
            leaveFrom="opacity-100 translate-y-0 sm:scale-100"
            leaveTo="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
          >
            <Dialog.Panel>
              {closeButton && (
                <div className={styles.buttonContainer}>
                  <button
                    type="button"
                    className={styles.close}
                    onClick={onClose}
                  >
                    <span className="sr-only">Close</span>
                    <FontAwesomeIcon
                      // @ts-ignore
                      icon={faTimes}
                    />
                  </button>
                </div>
              )}
              {children}
            </Dialog.Panel>
          </Transition.Child>
        </div>
      </Dialog>
    </Transition.Root>
  );
};
